import React from 'react';
import propTypes from 'prop-types';
import { Button } from '_ui-core-js/React/components/Button.jsx';
import { CssAnimation } from '_ui-core-js/React/components/CssAnimation.jsx';
import { LbxTheme } from './LbxTheme.jsx';

export function AtmosphereBanner(props) {

  const { 
    heading, 
    copy, 
    link, 
    theme, 
    inheritParentTheme, 
    onClickActions,
    gtmComponentGroup,
    gtmComponentName,
    gtmLabel
  } = props;

  const block = 'c-atmosphere-banner';
  const url = link?.url || link?.href;

  const onClickAction = _.find(link.dataAttributes, {key:'onClickAction'})
  let onClickFunction = _.noop();
    
  if (onClickAction?.value) {
      onClickFunction = onClickActions[onClickAction.value]
  }

  return (
    <LbxTheme 
    theme={theme}
    inherit={inheritParentTheme}
    applyThemeBackground={true}
    darkOverride={true}
    className={block}
    >
      <div className={`${block}__content-container container-xxxl utils__section-padding-small--uniform`}>
        <div className='col-12 col-xl-10 offset-xl-1'>
          <CssAnimation 
          enter={{ name: 'short-slide-up-fade-in', duration: 1 }} 
          triggerEnter={'in-view-init'}
          >
            <div className='row'>
              <div className='col-12 col-lg-4 h2'>
                { heading }
              </div>
              <div className='col-12 col-lg-8'>
                <p>{ copy }</p>
                {
                  link.label &&
                    <Button 
                    label={link.label} 
                    href={url} 
                    id={link.id} 
                    cssAnimation={true} 
                    onClickCallback={onClickFunction}
                    gtmComponentGroup={gtmComponentGroup}
                    gtmComponentName={gtmComponentName}
                    gtmLabel={gtmLabel} 
                    />
                }
              </div>
            </div>
          </CssAnimation>
        </div>
      </div>
    </LbxTheme>
  )
};

AtmosphereBanner.defaultProps = {
  heading: 'HEADING',
  body: 'Body text',
  inheritParentTheme: false
};

AtmosphereBanner.propTypes = {
  theme: propTypes.string.isRequired,
  heading: propTypes.string.isRequired,
  body: propTypes.string.isRequired,
  link: propTypes.object,
  inheritParentTheme: propTypes.bool,
  gtmComponentGroup: propTypes.string,
  gtmComponentName: propTypes.string,
  gtmLabel: propTypes.string
};